// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"DateTimeForm__srOnly--29nc-","hiddenInput":"DateTimeForm__hiddenInput--3iLzm","text":"DateTimeForm__text--jkslj"};